const initialState = {
  isLoadingRecentTransactions: false,
  isLoadingRecurringTypes: false,
  isLoadingSubscriptions: false,
  activeSubscription: false,
  allSubscriptions: [],
  recurringTypes: [],
  recentTransactions: [],
};

const walletReducer = (state = initialState, action) => {
  switch (action.type) {
    case "get_all_subscription_req":
      return {
        ...state,
        isLoadingSubscriptions: true,
      };
    case "get_all_subscriptions_success":
      return {
        ...state,
        isLoadingSubscriptions: false,
        allSubscriptions: action.payload.allSubscriptions,
        activeSubscription: action.payload.activeSubscription,
      };
    case "get_all_subscriptions_error":
      return {
        ...state,
        isLoadingSubscriptions: false,
        allSubscriptions: [],
        activeSubscription: false,
      };
    case "set_active_subscription":
      return {
        ...state,
        activeSubscription: action.payload,
      };
    case "get_recurring_types_req":
      return {
        ...state,
        isLoadingRecurringTypes: true,
      };
    case "get_recurring_types_success":
      return {
        ...state,
        isLoadingRecurringTypes: false,
        recurringTypes: action.payload,
      };
    case "get_recurring_types_error":
      return {
        ...state,
        isLoadingRecurringTypes: false,
        recurringTypes: [],
      };
    case "get_recent_transactions_req":
      return {
        ...state,
        isLoadingRecentTransactions: true,
      };
    case "get_recent_transactions_success":
      return {
        ...state,
        isLoadingRecentTransactions: false,
        recentTransactions: action.payload,
      };
    case "get_recent_transactions_error":
      return {
        ...state,
        isLoadingRecentTransactions: false,
        recentTransactions: [],
      };
    default:
      return state;
  }
};

export { walletReducer };
